export enum retrieveFrequencyEnum {
  EVERY_HOUR = '1h',
  EVERY_THIRTY_MINUTES = '30mn',
  EVERY_FIFTEEN_MINUTES = '15mn',
  EVERY_MINUTE = '1mn',
}
